import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import { TeaserMainDialogComponent } from './dialog/teaser-main-dialog/teaser-main-dialog.component';
import { SharedModule } from '@app/shared/shared.module';
import { TeaserDetailsComponent } from './components/teaser-details/teaser-details.component';

@NgModule({
  declarations: [TeaserDetailsComponent, TeaserMainDialogComponent],
  imports: [NoopAnimationsModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TeaserMainModule {}
